import {
    FAIL_MXI_CHAMPIONSHIP_CALENDAR,
    REQUEST_MXI_CHAMPIONSHIP_CALENDAR,
    SUCCESS_MXI_CHAMPIONSHIP_CALENDAR,
  } from '../../../actions/entities/mxi/championshipCalendar';
  import {createReducer} from '../../utilities';
  
  const initialState = {
    data: null,
    error: false,
    isFetching: false,
  };
  
  function requestFetch(state) {
    return {
      ...state,
      isFetching: true,
    };
  }
  
  function successFetch(state, action) {
    return {
      ...state,
      data: action.response,
      isFetching: false,
    };
  }
  
  function failFetch(state, action) {
    const {error} = action;
    return {
      ...state,
      isFetching: false,
      error,
    };
  }
  
  export default createReducer(initialState, {
    [REQUEST_MXI_CHAMPIONSHIP_CALENDAR]: requestFetch,
    [SUCCESS_MXI_CHAMPIONSHIP_CALENDAR]: successFetch,
    [FAIL_MXI_CHAMPIONSHIP_CALENDAR]: failFetch,
  });
  


// WEBPACK FOOTER //
// ./src/reducers/app/mxi/championshipCalendar.js